import {DocumentTemplateProgramService} from '../../../../services/documentTemplateProgramService';
import {createEntityThunks} from 'utils/createEntityThunks';
import {DocumentTemplateProgram} from '../../../../types/documentTemplateProgram';

const documentTemplateProgramFactory = (data: any) =>
  new DocumentTemplateProgram(data);

export const DocumentTemplateProgramThunks =
  createEntityThunks<DocumentTemplateProgram>(
    'documentTemplateProgram',
    DocumentTemplateProgramService,
    {activate: true, deactivate: true},
    documentTemplateProgramFactory,
  );
